import isNil from 'lodash/isNil'

export const toPascalCase = (value: string | null | undefined): string => {
  if (isNil(value)) return ''
  const trimmedValue = value.trim()
  return trimmedValue.charAt(0).toLocaleUpperCase() + trimmedValue.slice(1).toLocaleLowerCase()
}
